import { createAsyncThunk } from '@reduxjs/toolkit';
import { Order } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindOrderUserWise } from './interface';

export const findOrderUserWise = createAsyncThunk(
  'orderUserWise/findOrderUserWise', async (values: FindOrderUserWise, { rejectWithValue }) => {
    try {
      const response = await Order.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  });